<template>
  <div class="plv-iar-order-submit-bar">
    <div class="plv-iar-osb__text">
      <span>{{ iarTrans('order.priceLabel') }}</span>
      <span class="plv-iar-osb__price">
        {{ currency }}
        <span class="plv-iar-osb__price-integer">{{ price }}</span>
      </span>
    </div>
    <button class="plv-iar-osb__submit-btn" :disabled="disabled" @click="onSubmit">{{ iarTrans('order.submitBtnText') }}</button>
  </div>
</template>

<script>
import baseMixin from './basicMixin';

export default {
  mixins: [baseMixin],

  props: {
    /** 价格 */
    price: Number,
    /** 禁用 */
    disabled: {
      type: Boolean,
      default: false
    },
    /** 货币符号 */
    currency: {
      type: String,
      default: '￥'
    }
  },

  methods: {
    onSubmit() {
      if (this.disabled) return;
      this.$emit('submit');
    }
  }
};
</script>

<style lang="scss">
.plv-iar-order-submit-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 12px;
  background: #fff;

  .plv-iar-osb__text {
    font-size: 14px;
    color: #666666;
  }

  .plv-iar-osb__price {
    color: #F15D5D;
    font-size: 12px;
  }
  .plv-iar-osb__price-integer {
    font-size: 24px;
  }

  .plv-iar-osb__submit-btn {
    padding: 0 50px;
    height: 40px;
    line-height: 40px;
    color: #fff;
    border-radius: 40px;
    border: 1px solid #F15D5D;
    outline: none;
    background: #F15D5D;
    font-size: 14px;
  }
}
</style>
